/**
 * Created by denis on 04.09.2026
 */

const TestRestPayments = function () {
    RestPayments.call(this, "test", {
        sdk: SdkManager.SDK_TEST
    });
};

TestRestPayments.prototype = Object.create(RestPayments.prototype);
TestRestPayments.prototype.constructor = TestRestPayments;

TestRestPayments.prototype.purchase = function (product, callback) {
    this.bus.trigger("updateFrameSize");
    setTimeout(() => {
        // without the pay server the receipt has nowhere to wait for a restore
        const local = product.type === "subscription" || connector.config.norest;

        TestPayments.showPurchaseDialog(product, { canRestore: !local }, (choice, restoreDelay, raw) => {
            this.bus.trigger("updateFrameSize");

            if (choice === TestPayments.CHOICE_CANCEL) {
                callback(ERRORS.PURCHASE.CANCEL);
                return;
            }

            if (choice === TestPayments.CHOICE_ERROR) {
                callback(ERRORS.PURCHASE.UNKNOWN, undefined, raw);
                return;
            }

            const purchase = this.createPurchase(`${Date.now()}_${Math.floor(Math.random() * 1000000)}`, product, {
                purchaseToken: "test_token"
            });

            if (local) {
                callback(connector.CODE_SUCCEED, purchase);
                return;
            }

            const path = `/payments/add/${this.source}/${encodeURIComponent(connector.platform.getUserID())}`;

            ConnectorRestClient.post(path, { purchase, version: 2 }, () => {
                if (choice === TestPayments.CHOICE_RESTORE) {
                    // the pay server holds the receipt, the first validate stays pending and a restore delivers it after the chosen delay
                    this.pendingValidate = purchase.paymentId;
                    setTimeout(() => connector.payments.restoreCallback(), restoreDelay);
                }

                callback(connector.CODE_SUCCEED, purchase);
            }, (error) => {
                this.bus.trigger("stream:error", `TestRestPayments.purchase productId:${product.productId} ${JSON.stringify(error)}`);
                callback(ERRORS.PURCHASE.UNKNOWN);
            });
        });
    }, 1000);
};

TestRestPayments.prototype.validate = function (purchase, callback) {
    if (this.pendingValidate === purchase.paymentId) {
        delete this.pendingValidate;
        callback(connector.CODE_CANCELLED);
        return;
    }

    if (purchase.type === "subscription" || connector.config.norest) {
        callback(connector.CODE_SUCCEED, purchase);
        return;
    }

    RestPayments.prototype.validate.call(this, purchase, callback);
};

TestRestPayments.prototype.consume = function (purchase, callback) {
    if (purchase.type === "subscription" || connector.config.norest) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    RestPayments.prototype.consume.call(this, purchase, callback);
};

TestRestPayments.isAppropriate = function () {
    return TestSocial.isAppropriate() && Boolean(connector.config.testPlatform && connector.config.payApiURL);
};
